  // This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  env: "mapix_stage",
  appName: "Mapix",
  production: true,
  mapBoxToken:
    "pk.eyJ1IjoiZGFueWVsZ3R6IiwiYSI6ImNqeHY1cnJwejAxaGMzZm9jOXk4bWQ1MWYifQ.erh4k45vOrbGIpdT12F-ZA",
     botDirectLineKey:
      "F3BZu17cXFyQHQzXQoqe2pUhoZfPgMZLeOzrEFhOlgpnJ2g4wwSeJQQJ99BAACHYHv6AArohAAABAZBS1jKh.3qyiUzDW0CzykTn11vvFk7aeHkZL2QwvvvbSlfIN4E8zraNOEfs3JQQJ99BAACHYHv6AArohAAABAZBS1z1j",
  host: "https://mapixapistage.test.einteligent.com",
  signalRHost: "https://mapix-incommings.azurewebsites.net",
};


/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
